import { format } from 'date-fns'
import { queryConferenceList, queryConference, queryRecordDetail, confirmCocInvite, removeAttachFiles, addAttachFiles, joinCoc, cancelCoc } from '@/api/coc'
import { descInsertList } from '@/utils/ops'
import { CACHE_KEY, CONFERENCE_STATE } from '@/utils/constant'
import { db } from '@/utils/db'
import Vue from 'vue'
import { EDeviceType } from '@/pb/status_entity_pb'

const formatStr = 'yyyy年MM月dd日'

function transformQuery(oldCocsQuery, cocsQuery) {
  const { tags: oldQueryTags, corps: oldQueryCorps, beginTime: oldStartTime, endTime: oldEndTime } = oldCocsQuery
  const { tags, corps, beginTime, endTime, ...baseQuery } = cocsQuery

  const isNotEmptyTags = tags && tags.length > 0
  const isNotEmptyCorps = corps && corps.length > 0

  // 翻页时不会改变tags和corps, 判断一下减少storage操作
  if (oldQueryTags !== tags) {
    if (isNotEmptyTags) {
      Vue.ls.set(CACHE_KEY.QUERY_COC_TAG_IDS, tags)
    } else {
      Vue.ls.remove(CACHE_KEY.QUERY_COC_TAG_IDS)
    }
  }
  if (oldQueryCorps !== corps) {
    if (isNotEmptyCorps) {
      Vue.ls.set(CACHE_KEY.QUERY_COC_CORP_IDS, corps)
    } else {
      Vue.ls.remove(CACHE_KEY.QUERY_COC_CORP_IDS)
    }
  }

  if (oldStartTime !== beginTime || oldEndTime !== endTime) {
    if (!beginTime || !endTime) {
      Vue.ls.remove(CACHE_KEY.QUERY_COC_TIME_RANGE)
    } else {
      Vue.ls.set(CACHE_KEY.QUERY_COC_TIME_RANGE, [beginTime, endTime])
    }
  }

  if (isNotEmptyTags) {
    baseQuery.tags = tags
  }

  if (isNotEmptyCorps) {
    baseQuery.corps = corps
  }

  if (beginTime && endTime) {
    baseQuery.beginTime = beginTime
    baseQuery.endTime = endTime
  }
  return baseQuery
}

function resetState() {
  const cocsQuery = {
    limit: 20,
    offset: 0
  }

  try {
    const queryTagIdsCache = Vue.ls.get(CACHE_KEY.QUERY_COC_TAG_IDS)
    const queryCorpIdsCache = Vue.ls.get(CACHE_KEY.QUERY_COC_CORP_IDS)
    const timeRange = Vue.ls.get(CACHE_KEY.QUERY_COC_TIME_RANGE)

    if (queryTagIdsCache !== null) {
      cocsQuery.tags = queryTagIdsCache
    }

    if (queryCorpIdsCache !== null) {
      cocsQuery.corps = queryCorpIdsCache
    }

    if (timeRange !== null) {
      const [beginTime, endTime] = timeRange
      cocsQuery.beginTime = beginTime
      cocsQuery.endTime = endTime
    }
  } catch (err){}

  return {
    cocIdsByDate: {}, // 进行中和已完成 {[date]:cocId[]}
    cocDates: [], // 日期和上面的date对应
    recordByChannelId: {}, // 会议视频记录 {[roomId]: Record}
    currentCocId: null, // 协作详情，不包括通话记录列表
    cocById: {},
    tags: [],
    corps: [],
    // tagById: {},
    // corpById: {},
    cocsQuery,
    reqNextVer: Date.now(),
    notReadFileCount: 0
  }
}

const state = resetState()

const mutations = {
  resetNotReadFileCount (state) {
    state.notReadFileCount = 0
  },
  setNotReadFileCount (state) {
    state.notReadFileCount += 1
  },
  resetState(state) {
    const initState = resetState()
    for (const key in initState) {
      state[key] = initState[key]
    }
  },
  putCoc(state, coc) {
    const id = coc.conferenceId
    state.cocById = { ...state.cocById, [id]: { ...state.cocById[id], ...coc } }
  },
  patchActivedCoc(state, coc) {
    // 更新状态发生变化的数据
    const id = coc.conferenceId
    const origin = state.cocById[id]

    let originDate
    const currentDate = format(coc.beginTime * 1000, formatStr)

    if (!origin) {
      state.cocById = { ...state.cocById, [id]: coc }
    } else {
      originDate = format(origin.beginTime * 1000, formatStr)
      state.cocById = { ...state.cocById, [id]: { ...state.cocById[id], ...coc } }

      if (currentDate === originDate) {
        // 时间没有发生变化
        return
      }
    }

    const cocIdsByDate = { ...state.cocIdsByDate }

    if (originDate) {
      const cocIds = cocIdsByDate[originDate] || []
      const originDateIndex = cocIds.indexOf(id)
      // 移出原有排序数组
      if (originDateIndex > -1) {
        if (cocIds.length > 1) {
          const _cocIds = cocIds.slice(0)
          _cocIds.splice(originDateIndex, 1)
          cocIdsByDate[originDate] = _cocIds
        } else {
          const dateIndexofCocDates = state.cocDates.indexOf(originDate)
          if (dateIndexofCocDates > -1) {
            state.cocDates.splice(dateIndexofCocDates, 1)
          }
          delete cocIdsByDate[originDate]
        }
      }
    }

    if (state.cocDates.includes(currentDate)) {
      // 添加到新数组
      const otherCocIds = cocIdsByDate[currentDate].slice(0)
      let insertIndex = 0
      for (const ocId of otherCocIds) {
        console.log('===========================coc.beginTime', coc)
        if (state.cocById[ocId].beginTime < coc.beginTime) {
          break
        }
        insertIndex++
      }
      otherCocIds.splice(insertIndex, 0, id)
      cocIdsByDate[currentDate] = otherCocIds
    } else {
      descInsertList(currentDate, state.cocDates)
      cocIdsByDate[currentDate] = [id]
    }
    state.cocIdsByDate = cocIdsByDate
  },
  setCorps(state, corps) {
    state.corps = corps
  },
  setTags(state, tags) {
    state.tags = tags
  },
  removeCoc(state, conferenceId) {
    const cocDetail = state.cocById[conferenceId]
    if (!cocDetail) {
      return null
    }
    const { [conferenceId]: _, ...cocById } = state.cocById

    const dateFormat = format(cocDetail.beginTime * 1000, formatStr)

    const cocIdsByDate = state.cocIdsByDate[dateFormat].slice(0)
    const cocIdIndex = cocIdsByDate.indexOf(conferenceId)
    if (cocIdIndex === -1) {
      return
    }

    cocIdsByDate.splice(cocIdIndex, 1)

    if (cocIdsByDate.length === 0) {
      const cocDates = state.cocDates.slice(0)
      const dateIndex = cocDates.indexOf(dateFormat)
      if (dateIndex === -1) {
        return
      }
      cocDates.splice(dateIndex, 1)
      state.cocDates = cocDates

      const { [dateFormat]: _, ...otherCocIdsByDate } = state.cocIdsByDate

      state.cocIdsByDate = otherCocIdsByDate
    } else {
      state.cocIdsByDate = {
        ...state.cocIdsByDate,
        [dateFormat]: cocIdsByDate
      }
    }

    state.currentCocId = null

    state.cocById = cocById
  },
  addMoreCocs(state, cocs) {
    if (!cocs || cocs.length === 0) {
      return
    }
    const _cocs = [...cocs]

    _cocs.sort((a, b) => b.beginTime - a.beginTime)

    const dates = state.cocDates.slice(0) || []

    const cocIdsByDate = {
      ...state.cocIdsByDate
    }

    _cocs.forEach(coc => {
      const date = format(coc.beginTime * 1000, formatStr)

      descInsertList(date, dates)

      let idsByDate = cocIdsByDate[date]
      const conferenceId = coc.conferenceId

      if (!idsByDate) {
        idsByDate = []
        cocIdsByDate[date] = idsByDate
      }

      if (!idsByDate.includes(conferenceId)) {
        idsByDate.push(conferenceId)
      }
    })

    state.cocDates = dates
    state.cocIdsByDate = cocIdsByDate
  },
  clearCocs(state) {
    state.reqNextVer = Date.now()
    state.cocDates = []
    state.cocIdsByDate = {}
  },
  setCocDetail(state, detial) {
    state.cocById = { ...state.cocById, [detial.conferenceId]: detial }
  },
  setCocsQuery(state, cocsQuery) {
    state.cocsQuery = cocsQuery
  },
  setCurrentCocId(state, cocId) {
    state.currentCocId = cocId
  },
  setCocRecord(state, record) {
    state.recordByChannelId = {
      ...state.recordByChannelId,
      [record.chid]: record
    }
  }
}

/**
 * 说明：
 * chid, rooid, conferenceId, channelId是一个意思
 * 因来源接口不同而不同
 */

const actions = {
  async loadCocs({ commit, state }, query) {
    const cocsQuery = transformQuery(state.cocsQuery, { ...state.cocsQuery, ...query })

    commit('setCocsQuery', cocsQuery)
    const data = await queryConferenceList(cocsQuery)
    commit('addMoreCocs', data.items)
    commit('setTags', data.tags)
    commit('setCorps', data.corps)

    return data.items
  },
  // 拉取详情 (force参数在何时使用：例如除一个会议还没有完成或取消的两种情况外，其它情况都可能发生了变化)
  async fetchCocDetailGeneric({ state, rootState }, { id, force } = { force: false }) {
    // 结合上一个注释，也可以去掉force参数，直接拿状态判断
    const myId = rootState.userInfo.id
    if (!force && state.cocById[id]) {
      return state.cocById[id]
    }
    const data = await queryConference(id)

    const myCoc = data.members.find(({ userId }) => userId === myId)

    data.confirmStatus = myCoc.confirmStatus || 0
    data.attendStatus = myCoc.attendStatus || 0
    data.hostIsMe = data.hostId === myId
    data.mute = data?.mute || 0
    return data
  },
  viewCocDetail({ dispatch, commit }, conferenceId) {
    return dispatch('fetchCocDetail', { id: conferenceId, force: true }).then(data => {
      if (data.roomId) {
        dispatch('fetchRecordDetail', { force: true, channelId: data.roomId }).then(() => {
          commit('setCurrentCocId', conferenceId)
        })
      } else {
        commit('setCurrentCocId', conferenceId)
      }
    })
  },
  async fetchCocDetail({ commit, dispatch }, { id, force } = { force: false }) {
    const data = await dispatch('fetchCocDetailGeneric', { id, force })
    commit('setCocDetail', data)
    return data
  },
  async refreshCoc({ commit, dispatch }, id) {
    const data = await dispatch('fetchCocDetailGeneric', { id, force: true })
    commit('patchActivedCoc', data)

    if (data.roomId) {
      await dispatch('fetchRecordDetail', { force: true, channelId: data.roomId })
    }
    return data
  },
  async cancelCoc({ commit, dispatch }, conferenceId) {
    await cancelCoc(conferenceId)
    commit('removeCoc', conferenceId)
    dispatch('syncCocData', {
      conferenceId,
      changeData: { conferenceState: CONFERENCE_STATE.CANCELED },
      limit: Infinity
    })
  },
  async startCoc({ dispatch }, conferenceId) {
    await dispatch('startConferencePrematurely', conferenceId, { root: true })
    await dispatch('fetchCocDetail', { force: true, id: conferenceId })
  },
  async deleteAttachFile({ commit, state }, data) {
    const conferenceId = data.conferenceId
    await removeAttachFiles(data)
    const fids = data.files.map(({ fid }) => fid)
    const originCoc = state.cocById[conferenceId]
    commit('putCoc', {
      ...originCoc,
      files: originCoc.files.filter(file => !fids.includes(file.fid))
    })
  },
  async addAttachFiles({ commit, state }, data) {
    const conferenceId = data.conferenceId
    const resData = await addAttachFiles(data)
    const originCoc = state.cocById[conferenceId]
    commit('putCoc', {
      ...originCoc,
      files: (resData.files || []).concat(originCoc.files || [])
    })
  },
  // 获取通话记录
  async fetchRecordDetail({ commit, state }, { channelId, force } = { force: false }) {
    if (!force && state.recordByChannelId[channelId]) {
      return state.recordByChannelId[channelId]
    }
    const data = await queryRecordDetail(channelId)
    const records = data.records
    if (records && records.length > 0) {
      commit('setCocRecord', data.records[0])
    }
    return data
  },
  // 切换时
  reloadCocs({ commit }, data) {
    const cocsQuery = transformQuery(state.cocsQuery, { ...state.cocsQuery, ...data, offset: 0 })
    commit('setCocsQuery', cocsQuery)
    commit('clearCocs')
  },
  async syncCocData({ dispatch }, { conferenceId, changeData, limit }) {
    const _limit = limit || 1
    dispatch('notification/updateManyCocNotify', {
      patchFunc(_notify) {
        return _notify.conferenceId === conferenceId
      },
      defPatchData: changeData,
      limit: _limit
    }, { root: true })

    db.cocNotify.where({ conferenceId }).limit(_limit).modify(changeData)
  },
  async confirmCocInvite({ dispatch }, data) {
    const { confirmStatus, conferenceId } = data
    await confirmCocInvite(data)
    await dispatch('refreshCoc', data.conferenceId)

    dispatch('syncCocData', { conferenceId, changeData: { confirmStatus } })
  },
  joinConference({ state, dispatch, rootState }, conferenceId) {
    // const { conferenceId } = this.$route.params
    const { corpId, id: userId, name: nickName } = rootState.userInfo
    const params = {
      conferenceId,
      member: {
        corpId,
        userId,
        nickName,
        deviceType: EDeviceType.WEB
      }
    }
    // 查询协作信息
    return joinCoc(params).then(data => {
      // 当前协作已开始
      if (data.roomId && data.roomKey) {
        return dispatch('fetchCocDetail', { id: conferenceId, force: true }).then((data) => {
          // 从本地数据库获取自己的静音设置
          return dispatch('getMetuTypeSetting', undefined, { root: true }).then(microphoneClose => {
            // 加入房间
            return dispatch('joinConference', {
              conferenceId,
              roomId: data.roomId,
              roomKey: data.roomKey,
              roles: data.roles || [],
              microphoneClose
            }, { root: true })
          })
        })
      } else {
        // 尚未开始，跳转至该协作的详情页
        return Promise.reject(new Error('协作未进行'))
      }
    })
  }
}

const getters = {
  getCocIdsByDate: state => date => {
    return state.cocIdsByDate[date] || []
  },
  currentCoc: (state, getters) => {
    return getters.getCocDetialById(state.currentCocId) || {}
  },
  getRecordByChannelId: state => channelId => {
    return state.recordByChannelId[channelId] || null
  },
  getOriginCocById: state => id => state.cocById[id] || null,
  getCocDetialById: state => id => {
    const cocDetail = state.cocById[id]
    if (!cocDetail) {
      return null
    }
    const { members, ...currentCoc } = cocDetail
    const _members = members || []
    const memberGroupByCorpList = []
    const memberByUid = {}

    if (_members.length > 0) {
      const membersGroupByCorp = {}
      for (const member of _members) {
        const corpId = member.corpId
        if (!membersGroupByCorp[corpId]) {
          const { corpName, corpNameSpell } = member

          const corpMember = {
            corpId,
            corpName,
            corpNameSpell,
            members: []
          }

          memberGroupByCorpList.push(corpMember)

          membersGroupByCorp[corpId] = corpMember.members
        }
        membersGroupByCorp[corpId].push(member)

        memberByUid[member.userId] = member
      }
    }

    return { ...currentCoc, members: _members, memberGroupByCorp: memberGroupByCorpList, memberByUid }
  },
  offset: state => {
    return Object.values(state.cocIdsByDate).reduce(
      (prev, next) => prev + next.length,
      0
    )
  },
  getTagsByName: state => text => {
    const _str = text.trim()
    if (_str.length === 0) {
      return state.tags
    }
    return state.tags.filter(tag => tag.name.includes(_str))
  },
  getCorpsByName: state => text => {
    const _str = text.trim()
    if (_str.length === 0) {
      return state.corps
    }
    return state.corps.filter(corp => corp.corpName.includes(_str) || corp.corpNameSpell.includes(_str))
  },
  limit: state => state.cocsQuery.limit
}

const cocModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default cocModule
